import React, { FC } from 'react';
import {
  FontSecondaryLight,
  Icon,
  mediaQueries,
  spacingCalculator,
  spacingLeft,
  spacingTop, spacingTopBottom,
} from '@digando/react-component-library';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import { arrowIcon } from '../../../svg/NotFoundArrow';

interface IHintComponentProps {
  text?: string;
}

const HintComponent: FC<IHintComponentProps> = (props) => {
  const [t] = useTranslation('search-component');

  return (
    <ComponentWrapper>
      <Wrapper>
        {arrowIcon}
        <RightSide>
          <Icon icon="info" size={'25px'} color={'var(--primary-color)'}/>
          <span>{props.text ?? t('search-component:hint-location-search')}</span>
        </RightSide>
      </Wrapper>
    </ComponentWrapper>
  );
};

const RightSide = styled.div`
  ${spacingTopBottom(1)}
  display: flex;
  align-items: flex-start;
  background-color: rgba(255,255,255,0.9);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
  border-radius: 19px;
  max-width: calc(90vw - 62px);

  .icon {
    margin-top: ${spacingCalculator(1)};
    margin-left: ${spacingCalculator(1)};
  }

  span:not(.icon) {
    color: var(--font-color-medium);

    &:first-child{
      ${spacingTop(1)}
      ${spacingLeft(3)}
    }

    &:last-child{
      ${spacingLeft(1)}
      ${spacingTop(0.5)}
      width: 250px;
    }
  }

  svg {
    margin-bottom: ${spacingCalculator(2)};
    height: 56px;
    width: 62px;
  }

  @media ${mediaQueries.tablet} {
    svg {
      margin-bottom: ${spacingCalculator(1)};
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const ComponentWrapper = styled.div`
  ${FontSecondaryLight};
  font-size: var(--font-size-headline-h4);
  line-height: 24px;
  color: var(--font-color-light);

  @media ${mediaQueries.laptopL} {
    font-size: var(--font-size-headline-h3);
    line-height: 28px;
  }
`;

export default HintComponent;
